export default "__VITE_ASSET__BYU9cV_D__"